import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { Text } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { SubdomainRootTaken } from './SubdomainRootTaken';
export const GENERAL_ANONYMOUS_OVERRIDE_DATA_HOOK = 'general-anonymous-override';
export const GeneralAnonymousOverride = props => {
  const {
    domainName
  } = props;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  if (parseDomain(domainName ?? '').subdomain) {
    return /*#__PURE__*/React.createElement(SubdomainRootTaken, props);
  }
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainNameError, null, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    dataHook: GENERAL_ANONYMOUS_OVERRIDE_DATA_HOOK
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.storefront_results.error.domain_taken",
    values: {
      domainName
    },
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold"
    })]
  })));
};
//# sourceMappingURL=GeneralAnonymousOverride.js.map